import { render, staticRenderFns } from "./RateDescriptionPopup.vue?vue&type=template&id=6195cbec&scoped=true"
import script from "./RateDescriptionPopup.vue?vue&type=script&lang=js"
export * from "./RateDescriptionPopup.vue?vue&type=script&lang=js"
import style0 from "./RateDescriptionPopup.vue?vue&type=style&index=0&id=6195cbec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6195cbec",
  null
  
)

export default component.exports